import React from 'react';
import { getFormatNumber } from '../../utils/Currency';
import moment from 'moment';


export interface DisplayReceiptDetails {
    readonly referenceNumber: string
    readonly dateOfPayment: Date
    readonly amount: number
    readonly companyName: string
    readonly isBulkPayment: boolean
    readonly paymentMethodCardName: string
    readonly paymentMethodCardNumber: string
    readonly paymentMethodCardType: string
    readonly invoiceAmount: number
    readonly surchargingAmount: number
    readonly isSurchargingEnabled: boolean
}

export interface DisplayReceipt {
    readonly invoiceNumber: string
    readonly details: DisplayReceiptDetails
}

export interface ReceiptProps {
    readonly displayReceipts: Array<DisplayReceipt>
}

export class ReceiptBody extends React.Component<ReceiptProps, any> {

    render() {
        const receiptItems = this.props.displayReceipts.map(receipt => {
            return this.renderReceiptItem(receipt);
        });
        return (
            <div id='receipt'>
                {receiptItems}
            </div>
        );
    }

    renderReceiptItem(receipt: DisplayReceipt) {
        return (
            <div key={receipt.details.referenceNumber}>
                <div className="total__amount myob">
                    <div className="pull-left receipt-name">
                        <span>{ receipt.details.companyName }</span>
                    </div>
                    <div className="pull-right receipt-total-amount">
                        <p>Receipt Total</p>
                        <span>{ getFormatNumber(receipt.details.amount) }</span>
                    </div>
                </div>

                {
                    receipt.details.isBulkPayment &&
                    <div className="alert alert-info bulk-payment-receipt-information clearfix">
                        <img className="information-icon" src={require('../../assets/icons/information.svg')}/>
                        <span className="information-message">The receipt total is reflective of your bulk payment.</span>
                    </div>
                }

                <div className="payment-state">
                    <img src={require('../../assets/img/success_2x.png')} className="payment-state__success"
                         alt="Payment successful"/>
                    <p className="payment-state__message">Payment successful</p>
                </div>

                <div className="invoice-receipt-details">
                    <h4 className="invoice-receipt-details__title">Receipt details</h4>
                    <table className="table">
                        <tbody>
                        <tr>
                            <td>Invoice number
                                {
                                    receipt.details.isBulkPayment &&
                                        <span>(s)</span>
                                }
                            </td>
                            <td>{ receipt.invoiceNumber }</td>
                        </tr>
                        <tr>
                            <td>Payment date</td>
                            <td>{ moment(receipt.details.dateOfPayment).format('DD/MM/yyyy')}</td>
                        </tr>
                        {
                            receipt.details.isSurchargingEnabled &&
                                <tr>
                                    <td>Surcharging fee</td>
                                    <td>{ getFormatNumber(receipt.details.surchargingAmount)}</td>
                                </tr>
                        }
                        <tr>
                            <td>Amount paid</td>
                            <td>{ getFormatNumber(receipt.details.amount) }</td>
                        </tr>
                        <tr>
                            <td>Reference number</td>
                            <td>{ receipt.details.referenceNumber }</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="invoice-receipt-details">
                    <h4 className="invoice-receipt-details__title">Payment details</h4>
                    <table className="table">
                        <tbody>
                        <tr>
                            <td>Payment type</td>
                            <td>{ this.transferPaymentType(receipt.details.paymentMethodCardType)}</td>
                        </tr>
                        {
                            receipt.details.paymentMethodCardName &&
                                <tr>
                                    <td>Name</td>
                                    <td>{ receipt.details.paymentMethodCardName }</td>
                                </tr>
                        }
                        {
                            receipt.details.paymentMethodCardNumber && <tr>
                                <td>Number</td>
                                <td>{ receipt.details.paymentMethodCardNumber }</td>
                            </tr>
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    transferPaymentType = (paymentMethodCardType: string) => {
        if (paymentMethodCardType == 'paypal') return 'PayPal'
        return paymentMethodCardType
    }
}
